import { AVAILABLE_WALLET_OWNERS_QUERY } from "./CreateNewWallet";
import { REAL_ESTATE_OWNERS_QUERY } from "./Ownership/Queries";

export const availableOwnersRefetches = [
  { query: AVAILABLE_WALLET_OWNERS_QUERY },
  { query: REAL_ESTATE_OWNERS_QUERY }
];
